import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { RoleContainerModel } from '../../../../../models/aggregates/role';
import { ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseApiTemplateService<RoleContainerModel> {

  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'roles';
    this.httpClient = http;
  }

}


